import { Task } from '../api/types';

/**
 * Géométrie partagée entre l'éditeur interactif (GanttChart) et le rendu
 * imprimable (pdfPageSvg.ts) : mêmes conventions de dates UTC et de tracés
 * de connecteurs pour que l'export PDF corresponde visuellement à l'écran.
 */
export function parseISODate(iso: string): Date {
  return new Date(`${iso.slice(0, 10)}T00:00:00.000Z`);
}
export function diffDaysUTC(a: Date, b: Date): number {
  return Math.round((b.getTime() - a.getTime()) / 86400000);
}
export function addDaysUTC(d: Date, n: number): Date {
  return new Date(d.getTime() + n * 86400000);
}

export function curvedPath(x1: number, y1: number, x2: number, y2: number): string {
  const c = Math.max(24, Math.abs(x2 - x1) / 2);
  return `M ${x1},${y1} C ${x1 + c},${y1} ${x2 - c},${y2} ${x2},${y2}`;
}

/** Chemin composé uniquement d'horizontales et de verticales (voir Paramètres > Connecteurs). */
export function orthogonalPath(x1: number, y1: number, x2: number, y2: number): string {
  if (y1 === y2) return `M ${x1},${y1} L ${x2},${y2}`;
  const midX = x1 + (x2 - x1) / 2;
  return `M ${x1},${y1} L ${midX},${y1} L ${midX},${y2} L ${x2},${y2}`;
}

/** Profondeur d'indentation de chaque tâche dans l'arborescence (0 = racine) — voir parentId. */
export function computeDepthById(tasks: Task[]): Map<string, number> {
  const byId = new Map(tasks.map((t) => [t.id, t]));
  const cache = new Map<string, number>();
  const depthOf = (id: string): number => {
    if (cache.has(id)) return cache.get(id)!;
    const parentId = byId.get(id)?.parentId ?? null;
    const d = parentId ? depthOf(parentId) + 1 : 0;
    cache.set(id, d);
    return d;
  };
  for (const t of tasks) depthOf(t.id);
  return cache;
}
